module.exports = __webpack_public_path__ + "static/media/icon-twitter.d1044b25.png";